import { render } from "./MyCollection.vue?vue&type=template&id=5c7e5621"
import script from "./MyCollection.vue?vue&type=script&lang=js"
export * from "./MyCollection.vue?vue&type=script&lang=js"
script.render = render

export default script